////    CORE    ////
import { Component, Input, OnInit } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { filter } from 'rxjs'


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() connected: any
  menuItem = "Gestion des documents"
  public route: any = ''

  constructor(private _router: Router){
    this.route = this._router.url
  }

  ngOnInit(): void {
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      this.menuItem = !window.location.pathname.includes('statistiques') ? 'Gestion des documents' : 'Partages / statistiques réalisés'
    })
  }

}
